import { render, staticRenderFns } from "./user-test-dialog.vue?vue&type=template&id=73089c08&scoped=true&"
import script from "./user-test-dialog.vue?vue&type=script&lang=js&"
export * from "./user-test-dialog.vue?vue&type=script&lang=js&"
import style0 from "./user-test-dialog.vue?vue&type=style&index=0&id=73089c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73089c08",
  null
  
)

export default component.exports